// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ion-item {\n  --inner-padding-end: 0!important;\n}", "",{"version":3,"sources":["webpack://./src/app/core/component/form-inputs/phone-input/phone-input.component.scss"],"names":[],"mappings":"AACA;EACI,gCAAA;AAAJ","sourcesContent":["\nion-item {\n    --inner-padding-end: 0!important;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
